import styled from "styled-components";
import { lighten } from "polished";

export const CheckboxContainer = styled.div<any>`
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
  background: ${props => props.active ? props.theme.colors.primary : '#fff'};
  color: ${props => props.active ? '#fff' : ''};
  margin: 5px;
  padding: 5px;
  border-radius: 5px;
  transition: background-color 0.2s;

  &:hover {
    cursor: ${(props) => props.active ? 'default' : 'pointer'};
    background: ${(props) => props.active ? '' : lighten(0.35, props.theme.colors.gray)};
  }
`;
